export default __webpack_public_path__ + "static/media/section2-pic1.0479ca2c.png";